<template>
  <div class="scatterplot-container">
    <scatterplot :studySelected="studySelected"/>
  </div>
</template>

<script>
import Scatterplot from './Scatterplot.vue'

export default {
    components: { Scatterplot },

    name: "scatterplot-container",

    props: ['view', 'studySelected'],

    data: () => ({
    }),
    
    computed: {
      // normalTracks() {
      //   return Object.fromEntries(Object.entries(this.trackData).filter(([track, data]) => {
      //     return data.tissue === 'normal'
      //   }))
      // },
      // tumorTracks() {
      //   return Object.fromEntries(Object.entries(this.trackData).filter(([track, data]) => {
      //     return data.tissue === 'tumor'
      //   }))
      // },
      // combinedTracks() {},
    },

    mounted() {
    },
  }
</script>

<style>
.scatterplot-container {
    width: 100%;
    /* height: 200%; */
    aspect-ratio: 1;
    min-width: 600px;
    display: flex;
    flex-direction: column;
    /* margin: 10px; */
    /* padding-left: 10px; */
    overflow: scroll;
    /* height: 100%; */
}
</style>